import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";
import store from "../../store/index.js";
import { i18n } from "../../main";
import {
  validatePasswordMinCharacters,
  validatePasswordMinLowerCase,
  validatePasswordMinNumbers,
  validatePasswordMinSpecialCharacters,
  validatePasswordMinUpperCase,
} from "../../utils/index.js";

// CONFIGURAÇÃO DE COSTUMIZAÇÃO

Vue.prototype.$lojas_usuarios = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      usuarioAddEdit: "new",
      loja_selecionada: "",
      lojas_loading: false,
      modalSelectStore: false,
      recovery_loading: false,
      user: {
        avatar: "",
        nome: "",
        email: "",
        senha: "",
        show_senha: false,
        senha2: "",
        show_senha2: false,
        old_password: "",
        show_old_pass: false,
        error: {
          nome: [],
          email: [],
          old_password: [],
          senha: [],
          senha2: [],
        },
      },
      cadastro: {
        avatar: { imagem: null },
        iduserloja: "",
        nome: "",
        email: "",
        senha: "",
        is_app: false,
        loading: false,
        urlHome: "",
        status: "ACEITE_TERMOS",
        perfil: "",
        eventos: null,
        editar_evento: false,
        bloqueado: false,
        error: {
          nome: [],
          email: [],
          email2: [],
          old_password: [],
          senha: [],
          senha2: [],
          status: [],
          perfil: [],
          eventos: [],
        },
      },
      usuarios: [],
      usuarios_loading: false,
      usuarios_loading_button: false,
      loja_usuarios: "",
      filtros: [],
      filter: {
        nome: "",
        email: "",
        status: "",
        loja: "",
        dataInicio: "",
        dataFim: "",
        perfil: "",
        error: {
          dataInicio: [],
          dataFim: [],
        },
      },
    };
  },
  methods: {
    // ---- LOGIN ---- //
    async getLogin(login, user, senha, loja, token) {
      let recaptcha = "";
      if (process.env.NODE_ENV === "production") {
        recaptcha = await window.grecaptcha.getResponse();
      }
      if (login) {
        this.cadastro.loading = true;
        this.$axios
          .post(this.ENDPOINTS.LOGIN_USUARIO_LOJA, {
            captcha: recaptcha,
            email: user,
            senha: senha,
            loja: loja,
            is_app: false,
          })
          .then(response => {
            if (response && response.access_token) {
              let dados = response.info;
              store.dispatch("setStore", dados);
              this.$axios.setCookie("oe_jwt", response.access_token);
              this.$axios.setLocal("oe_user_info", dados);
              this.$config.user_type = dados?.user_type;
              store.dispatch("setUserType", dados?.user_type);
              store.dispatch("setUserInfo", dados);
              this.logado = true;
              router.push("/home");
            }
          })
          .catch(() => {
            this.cadastro.loading = false;
          })
          .finally(() => {
            this.cadastro.loading = false;
            if (process.env.NODE_ENV === "production") {
              window.grecaptcha.reset();
            }
          });
      } else {
        this.$axios
          .post(
            this.ENDPOINTS.LOGIN_USUARIO_LOJA,
            JSON.stringify({
              loja: loja,
              token_acesso: token,
              is_app: false,
            })
          )
          .then(response => {
            let dados = response.info;
            this.$axios.setLocal("oe_user_info", dados);
            this.user.avatar = dados.avatar;
            this.user.nome = dados.nome;
            this.user.email = dados.email;
          })
          .catch(error => {
            throw new Error(error);
          });
      }
    },

    // ---- LISTAR USUÁRIOS ---- //
    getUsuariosLoja(loja) {
      this.cadastro.loading = true;
      if (loja === "") {
        return;
      }
      this.$axios
        .post(this.ENDPOINTS.LISTAR_USUARIO_LOJA, { loja: loja })
        .then(response => {
          this.usuarios = response;
          this.lojas_loading = false;
          this.cadastro.loading = false;
        });
    },

    sendAppLoginInfoEmail() {
      let dados = {
        conta: store.getters.storeSequencial,
        login: this.cadastro.email,
        senha: this.cadastro.senha,
        nome: this.cadastro.nome,
      };
      this.$axios
        .post(this.ENDPOINTS.SEND_INFO_EMAIL, dados)
        .then(response => {
          if (response.sucesso) {
            return response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    // ---- ENVIAR E-MAIL SEM A SENHA ---- //
    sendAppLoginInfoEmailNoPassword() {
      if (
        this.cadastro.nome == "" ||
        this.cadastro.nome == undefined ||
        this.cadastro.nome.length < 3
      ) {
        this.$config.alert(
          i18n.t("registrations.users.name-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.nome = i18n.t("registrations.users.name-error");
        return;
      }

      if (this.cadastro.email == "" || this.cadastro.email == undefined) {
        this.$config.alert(
          i18n.t("registrations.users.email-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.email = i18n.t("registrations.users.email-error");
        return;
      }

      if (!this.$config.validarEmail(this.cadastro.email)) {
        this.$config.alert(
          i18n.t("registrations.users.invalid-email"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.email = i18n.t("registrations.users.invalid-email");
        return;
      }

      let dados = {
        loja: store.getters.storeSequencial,
        email: this.cadastro.email,
        nome: this.cadastro.nome,
      };
      this.$axios
        .post(this.ENDPOINTS.SEND_INFO_EMAIL_NO_PASSWORD, dados)
        .then(response => {
          if (response.sucesso) {
            return response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    // ---- DESABILITAR USUÁRIO ---- //
    desabilitarUsuarioLoja(idusuario) {
      this.$axios
        .put(this.ENDPOINTS.DESABILITAR_USUARIO_LOJA + idusuario, {
          loja: store.getters.storeSequencial,
        })
        .then(response => {
          if (response) {
            this.getUsuariosLoja(store.getters.storeSequencial);
          }
        });
    },
    habilitarUsuario(idusuario) {
      this.$axios
        .put(this.ENDPOINTS.HABILITAR_USUARIO_LOJA + idusuario, {
          status: "ATIVO",
          loja: store.getters.storeSequencial,
        })
        .then(response => {
          if (response) {
            this.getUsuariosLoja(store.getters.storeSequencial);
          }
        });
    },

    // ---- ALTERAR USUÁRIO ---- //
    alterarUsuarioLoja() {
      this.cadastro.loading = true;
      if (this.cadastro.perfil == "APP") {
        this.cadastro.is_app = true;
      } else {
        this.cadastro.is_app = false;
      }
      if (this.cadastro.perfil !== "EVENTO") {
        this.cadastro.eventos = null;
        this.cadastro.editar_evento = false;
      }
      this.cadastro.loading = true;
      let idusuario = this.cadastro.iduserloja;
      let dados = {
        loja: store.getters.storeSequencial,
        avatar: this.cadastro.avatar.imagem,
        nome: this.cadastro.nome,
        email: this.cadastro.email,
        status: this.cadastro.status,
        is_app: this.cadastro.is_app,
        perfil: this.cadastro.perfil,
        nideventos: this.cadastro.eventos,
        editar_evento: this.cadastro.editar_evento,
      };

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_USUARIO_LOJA + idusuario, dados)
        .then(response => {
          if (response) {
            this.limpaFormularioDeUsuario();
            router.push({
              name: "producersUsers",
            });
            this.$axios.setLocal("confirmEditLojasUsuarios", true);
            this.getUsuariosLoja(store.getters.storeSequencial);
          }
        });
    },

    // ---- CADASTRAR USUÁRIO ---- //
    async cadastrarUsuario() {
      this.cadastro.loading = true;
      if (this.cadastro.perfil == "APP" || this.cadastro.perfil == "ADMIN") {
        this.cadastro.is_app = true;
      } else {
        this.cadastro.is_app = false;
      }
      let dados = {
        loja: store.getters.storeSequencial,
        avatar: this.cadastro.avatar.imagem,
        nome: this.cadastro.nome,
        email: this.cadastro.email,
        senha: this.cadastro.senha,
        status: this.cadastro.status,
        is_app: this.cadastro.is_app,
        bloqueado: this.cadastro.bloqueado,
        perfil: this.cadastro.perfil,
        nideventos: this.cadastro.eventos,
        editar_evento: this.cadastro.editar_evento,
        url_home: this.cadastro.urlHome,
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_USUARIO_LOJA, dados)
        .then(response => {
          if (response.sucesso) {
            this.limpaFormularioDeUsuario();
            router.push({
              name: "producersUsers",
            });
            this.getUsuariosLoja(store.getters.storeSequencial);
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- FUNÇÃO PARA REDEFINIR A SENHA ---- //
    async trocarSenha() {
      let idusuario = this.$axios.getLocal("oe_user_info")?.data?.idusuario;
      this.$axios.getCookie("oe_jwt");
      if (this.user.old_password.length == 0) {
        this.$config.alert(
          "Insira sua senha atual!",
          this.$config.dados.errorColor
        );
        this.user.error.old_password = "Insira sua senha atual";
        return;
      }

      const password = this.user.senha;

      if (validatePasswordMinCharacters(password)) {
        this.$config.alert(
          i18n.t("common.password-requirements.error-messages.min-length"),
          this.$config.dados.errorColor
        );
        this.user.error.senha2 = i18n.t(
          "common.password-requirements.min-length"
        );
        return;
      }

      if (validatePasswordMinNumbers(password)) {
        this.$config.alert(
          i18n.t("common.password-requirements.error-messages.min-numbers"),
          this.$config.dados.errorColor
        );
        this.user.error.senha2 = i18n.t(
          "common.password-requirements.min-numbers"
        );
        return;
      }

      if (validatePasswordMinLowerCase(password)) {
        this.$config.alert(
          i18n.t(
            "common.password-requirements.error-messages.min-non-capital-characters"
          ),
          this.$config.dados.errorColor
        );
        this.user.error.senha2 = i18n.t(
          "common.password-requirements.min-non-capital-characters"
        );
        return;
      }

      if (validatePasswordMinUpperCase(password)) {
        this.$config.alert(
          i18n.t(
            "common.password-requirements.error-messages.min-capital-characters"
          ),
          this.$config.dados.errorColor
        );
        this.user.error.senha2 = i18n.t(
          "common.password-requirements.min-capital-characters"
        );
        return;
      }

      if (validatePasswordMinSpecialCharacters(password)) {
        this.$config.alert(
          i18n.t("common.password-requirements.min-special-characters"),
          this.$config.dados.errorColor
        );
        this.user.error.senha2 = i18n.t(
          "common.password-requirements.min-special-characters"
        );
        return;
      }

      if (this.user.senha != this.user.senha2) {
        this.$config.alert(
          "As senhas são incompatíveis!",
          this.$config.dados.errorColor
        );
        this.user.error.senha2 = "As senhas são incompatíveis!";
        return;
      }
      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_SENHA_USUARIO_LOJA + idusuario,
          JSON.stringify({
            loja: store.getters.storeSequencial,
            senha_antiga: this.user.old_password,
            senha_nova: this.user.senha,
          })
        )
        .then(response => {
          if (response) {
            localStorage.removeItem("token");
            this.$axios.destroy(true);
            this.user.old_password = "";
            this.user.show_old_pass = "password";
            this.user.senha = "";
            this.user.show_senha = "password";
            this.user.senha2 = "";
            this.user.show_senha2 = "password";
            if (location.pathname != "login") {
              setTimeout(() => {
                router.push("/");
              }, 3000);
            }
          }
        });
    },

    filtroUsuarios() {
      this.cadastro.loading = true;
      this.usuarios_loading_button = true;
      this.filtros = [];

      function formatDate(date) {
        const dateParts = date.split("/");
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        return formattedDate;
      }

      if (this.filter.nome !== "") {
        this.filtros.push({
          campo: "nome",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nome,
        });
      }

      if (this.filter.email !== "") {
        this.filtros.push({
          campo: "email",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.email,
        });
      }

      if (this.filter.status !== "" && this.filter.status !== null) {
        this.filtros.push({
          campo: "status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (this.filter.dataInicio !== "" && this.filter.dataInicio.length < 10) {
        this.cadastro.loading = false;
        this.usuarios_loading_button = false;
        this.$config.alert(
          "Verifique o período de datas pesquisado!",
          this.$config.dados.errorColor
        );
        this.filter.error.dataInicio =
          "Verifique o período de datas pesquisado!";
        return;
      }

      if (this.filter.dataFim !== "" && this.filter.dataFim.length < 10) {
        this.cadastro.loading = false;
        this.usuarios_loading_button = false;
        this.$config.alert(
          "Verifique o período de datas pesquisado!",
          this.$config.dados.errorColor
        );
        this.filter.error.dataFim = "Verifique o período de datas pesquisado!";
        return;
      }

      if (this.filter.dataInicio !== "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: formatDate(this.filter.dataInicio) + " 00:00",
        });
      }

      if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: formatDate(this.filter.dataFim) + " 23:59",
        });
      }

      if (this.filter.perfil != "") {
        this.filtros.push({
          campo: "perfil",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.perfil,
        });
      }

      let filtered = this.filtros;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_USUARIO_LOJA,
          JSON.stringify({
            loja: store.getters.storeSequencial,
            filtros: filtered,
          })
        )
        .then(response => {
          this.usuarios = response;
          this.cadastro.loading = false;
          this.usuarios_loading_button = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    // ---- FUNÇÃO QUE VALIDA O CADASTRO ---- //
    async validarCadastro() {
      if (
        this.cadastro.nome == "" ||
        this.cadastro.nome == undefined ||
        this.cadastro.nome.length < 3
      ) {
        this.$config.alert(
          i18n.t("registrations.users.name-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.nome = i18n.t("registrations.users.name-error");
        return;
      }

      if (this.cadastro.email == "" || this.cadastro.email == undefined) {
        this.$config.alert(
          i18n.t("registrations.users.email-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.email = i18n.t("registrations.users.email-error");
        return;
      }

      if (!this.$config.validarEmail(this.cadastro.email)) {
        this.$config.alert(
          i18n.t("registrations.users.invalid-email"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.email = i18n.t("registrations.users.invalid-email");
        return;
      }

      if (this.usuarioAddEdit == "new") {
        const password = this.cadastro.senha;

        if (validatePasswordMinCharacters(password)) {
          this.$config.alert(
            i18n.t("common.password-requirements.error-messages.min-length"),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-length"
          );
          return;
        }

        if (validatePasswordMinNumbers(password)) {
          this.$config.alert(
            i18n.t("common.password-requirements.error-messages.min-numbers"),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-numbers"
          );
          return;
        }

        if (validatePasswordMinLowerCase(password)) {
          this.$config.alert(
            i18n.t(
              "common.password-requirements.error-messages.min-non-capital-characters"
            ),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-non-capital-characters"
          );
          return;
        }

        if (validatePasswordMinUpperCase(password)) {
          this.$config.alert(
            i18n.t(
              "common.password-requirements.error-messages.min-capital-characters"
            ),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-capital-characters"
          );
          return;
        }

        if (validatePasswordMinSpecialCharacters(password)) {
          this.$config.alert(
            i18n.t(
              "common.password-requirements.error-messages.min-special-characters"
            ),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-special-characters"
          );
          return;
        }
      }

      if (this.cadastro.status === "" || this.cadastro.status == undefined) {
        this.$config.alert(
          i18n.t("registrations.users.status-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.status = i18n.t("registrations.users.status-error");
        return;
      }

      if (this.cadastro.perfil === "" || this.cadastro.perfil == undefined) {
        this.$config.alert(
          i18n.t("registrations.users.profile-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.perfil = i18n.t(
          "registrations.users.profile-error"
        );
        return;
      }

      if (this.cadastro.perfil === "EVENTO" && this.cadastro.eventos <= 0) {
        this.$config.alert(
          i18n.t("registrations.users.event-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.eventos = i18n.t("registrations.users.event-error");
        return;
      }

      if (this.usuarioAddEdit == "editar") {
        this.alterarUsuarioLoja();
        return;
      }

      this.cadastrarUsuario();
    },

    async recuperarSenha(email, loja) {
      let recaptcha = "";
      if (process.env.NODE_ENV === "production") {
        recaptcha = await window.grecaptcha.getResponse();
      }
      if (recaptcha == "" && process.env.NODE_ENV === "production") {
        window.grecaptcha.reset();
        return;
      }

      this.recovery_loading = true;

      let dados = {
        email: email,
        loja: loja,
        url: process.env.VUE_APP_PANEL_URL + "recuperar-senha-lojista",
        captcha: recaptcha,
      };

      this.$axios
        .post(this.ENDPOINTS.EMAIL_RECUPERAR_SENHA_LOJISTA, dados)
        .then(response => {
          this.recovery_loading = false;
          window.grecaptcha.reset();
          if (response && response.sucesso) {
            document.getElementsByClassName(
              "modal-body-esqueci-senha"
            )[0].style.display = "none";
            return;
          }
        })
        .catch(() => {
          this.recovery_loading = false;
          if (process.env.NODE_ENV === "production") {
            window.grecaptcha.reset();
          }
        });
    },

    recoverySenha(dados) {
      this.recovery_loading = true;
      this.$axios
        .put(this.ENDPOINTS.RECUPERAR_SENHA_LOJISTA, dados)
        .then(response => {
          if (response) {
            this.recovery_loading = false;
            router.push("/");
          }
        })
        .catch(error => {
          this.recovery_loading = false;
          throw new Error(error);
        });
    },

    limpaFormularioDeUsuario() {
      this.cadastro.nome = "";
      this.cadastro.email = "";
      this.cadastro.senha = "";
      this.cadastro.status = "ACEITE_TERMOS";
      this.cadastro.is_app = false;
      this.cadastro.perfil = "";
      this.cadastro.eventos = [];
      this.cadastro.editar_evento = false;
      this.cadastro.error.nome = "";
      this.cadastro.error.email = "";
      this.cadastro.error.senha = "";
      this.cadastro.error.status = "";
      this.cadastro.error.perfil = "";
      this.cadastro.avatar.imagem = null;
      delete this.cadastro.avatar.object;
    },

    limpaFiltros() {
      this.filter.nome = "";
      this.filter.email = "";
      this.filter.status = "";
      this.filter.loja = "";
      this.filter.dataInicio = "";
      this.filter.dataFim = "";
      this.filter.perfil = "";
      this.filter.error.dataInicio = "";
      this.filter.error.dataFim = "";
      this.filtros = [];
    },
  },
});
